
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { Rito } from '@app/models/rito.model';

@Injectable()
export class RitoService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }

  gravar(rito: Rito): Observable<any> {
    return this.http.post<any>(this.URL_API + "configuracoes/rito", rito).pipe(
      catchError((error: any) => observableThrowError(error)));
  }


  deletar(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `configuracoes/rito/${id}`).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

  obterPorId(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `configuracoes/rito/${id}`);
  }


  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http.get<any>(this.URL_API + `configuracoes/rito/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

  // obterTodos() { 
  //   return this.http.get(this.URL_API + `rito`)
  //     .map((res: Response) => res.json());
  // }

}
